export default "__VITE_ASSET__CABTXMC2__"